/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import GoogleMapReact from 'google-map-react';
import styles from './ViewMap.module.css';
import { FaMapMarkerAlt } from "react-icons/fa";

export default function ViewMap({ profile }) {
  const location = React.useMemo(() => ({
    lat: parseFloat(profile.latitude),
    lng: parseFloat(profile.longitude)
  }), [profile])

  if (!location) return null
  const { lat, lng } = location
  if (!lat || !lng) return null

  const MapPointer = () => <FaMapMarkerAlt size={14} color="red" />

  return (
    <div className={styles.map}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY }}
        defaultCenter={{ lat, lng }}
        defaultZoom={profile.zoom || 13} >
        <MapPointer lat={lat} lng={lng} />
      </GoogleMapReact>
    </div>
  )
}
